"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFavoritesUseCase = void 0;
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const favorites_context_1 = require("../../providers/favorites/favorites.context");
function useGetFavoritesUseCase(params) {
    const { favoritesRepository, queryContext } = params;
    const queryFn = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        return yield favoritesRepository.getAllItems();
    }), [favoritesRepository]);
    const { data, refetch } = (0, react_query_1.useQuery)({
        queryKey: favorites_context_1.FavoritesQueryKeys.GetAll(favoritesRepository.strategyName),
        queryFn,
        initialData: [],
        enabled: false,
        context: queryContext,
        notifyOnChangeProps: ['data', 'refetch'],
    });
    return [data, refetch];
}
exports.useGetFavoritesUseCase = useGetFavoritesUseCase;
